{
    "TelsysList_Column_TelSysID": "AUSWEIS",
    "TelsysList_Column_Description": "Beschreibung",
    "TelsysList_Column_Trial": "Versuch",
    "TelsysList_Trial_Yes": "Ja",
    "TelsysList_Trial_No": "NEIN",
    "TelsysList_Column_PlatformType": "Plattformtyp",
    "TelsysList_Column_Licence": "Lizenz",
    "TelsysList_Column_Partitions": "Partitionen",
    "TelsysList_Column_Extensions": "Erweiterungen",
    "TelsysList_Column_AcdAgents": "ACD-Agenten",
    "TelsysList_Column_AppUsers": "Anwendungsbenutzer",
    "TelsysList_Column_Status": "Status",
    "TelsysList_Filter_PlatformType": "Plattformtyp",
    "TelsysList_Filter_ReportLicence": "Meldelizenz",
    "TelsysList_Filter_ModuleStatus": "Modulstatus",
    "TelsysList_LicenceFilter_HistoricOnly": "Nur historisch",
    "TelsysList_LicenceFilter_Standard": "Standard \/ BLF",
    "TelsysList_LicenceFilter_Enterprise": "Unternehmen",
    "TelsysList_LicenceFilter_Acd": "ACD",
    "TelsysList_LicenceFilter_None": "Keiner",
    "TelsysList_LicenceFilter_Mixed": "Gemischt",
    "TelsysList_LicenceFilter_Unknown": "Unbekannt",
    "TelsysList_ModuleStatus_mNeg1": "Unbekannt",
    "TelsysList_ModuleStatus_m0": "Gerade erst gestartet oder stillgelegt",
    "TelsysList_ModuleStatus_m1": "Angehalten",
    "TelsysList_ModuleStatus_m2": "Beginn",
    "TelsysList_ModuleStatus_m3": "Ende",
    "TelsysList_ModuleStatus_m4": "Deaktiviert",
    "TelsysList_ModuleStatus_m5": "Läuft (inaktiv)",
    "TelsysList_ModuleStatus_m6": "Läuft (ohne Lizenz)",
    "TelsysList_ModuleStatus_m7": "Kernkommunikation starten",
    "TelsysList_ModuleStatus_m8": "Startgeräteüberwachung",
    "TelsysList_ModuleStatus_m9": "Unterbrechung der Kommunikation",
    "TelsysList_ModuleStatus_m10": "Läuft",
    "TelsysList_ModuleStatus_m11": "Wird ausgeführt (Warnungen)",
    "TelsysList_ModuleStatus_m12": "Synchronisierung",
    "TelsysList_ModuleStatus_m13": "Synchronisiert",
    "TelsysList_ModuleStatus_m14": "Synchronisiert (Warnungen)",
    "TelsysList_ModuleStatus_m15": "Synchronisierung fehlgeschlagen",
    "TelsysList_ModuleStatus_m16": "Nicht in Betrieb",
    "TelsysList_ModuleStatus_m17": "Die Kommunikation endete unschön.",
    "TelsysList_ModuleStatus_m18": "Synchronisierung fehlgeschlagen",
    "TelsysList_ModuleStatus_m19": "Bots deaktiviert",
    "TelsysList_ModuleStatus_m20": "Bots deaktiviert (Warnungen)",
    "TelsysList_ModuleStatus_m21": "Inaktiv (falsche Berechtigung)",
    "TelsysList_CountLink_PartitionsAria": "Offene Partitionen, die zu diesem Telefonieserver gefiltert wurden",
    "TelsysList_CountLink_ExtensionsAria": "Offene Nebenstellen (Codes), die an diesen Telefonieserver gefiltert wurden",
    "TelsysList_CountLink_AcdAgentsAria": "Offene ACD-Agenten, die auf diesen Telefonieserver gefiltert wurden",
    "TelsysList_CountLink_AppUsersAria": "Benutzer der offenen Anwendung wurden auf diesen Telefonieserver gefiltert.",
    "NAME": "TelsysListLanguage"
}